import { httpClient } from '../http/httpClient.js';
import { buildQueryString, ensureSuccessPayload, getCollection } from './serviceUtils.js';

const TASK_TYPES_API_URL = '/api/task-types';

const buildTaskTypesUrl = (params = {}) => {
  const queryString = buildQueryString(params);
  return queryString ? `${TASK_TYPES_API_URL}?${queryString}` : TASK_TYPES_API_URL;
};

export const taskTypeService = {
  getTaskTypes: async (params = {}) => {
    const payload = ensureSuccessPayload(
      await httpClient.get(buildTaskTypesUrl(params)),
      'No se pudieron cargar los tipos de tarea.'
    );

    return {
      taskTypes: getCollection(payload, ['taskTypes', 'data']),
      pagination: payload?.pagination || null,
      payload
    };
  },

  createTaskType: async (taskTypeData) => {
    const payload = await httpClient.post(TASK_TYPES_API_URL, { data: taskTypeData });
    return ensureSuccessPayload(payload, 'No se pudo crear el tipo de tarea.');
  },

  updateTaskType: async (taskTypeName, taskTypeData) => {
    const payload = await httpClient.put(`${TASK_TYPES_API_URL}/${encodeURIComponent(taskTypeName)}`, {
      data: taskTypeData
    });
    return ensureSuccessPayload(payload, 'No se pudo actualizar el tipo de tarea.');
  },

  deleteTaskType: async (taskTypeName) => {
    const payload = await httpClient.delete(`${TASK_TYPES_API_URL}/${encodeURIComponent(taskTypeName)}`);
    return ensureSuccessPayload(payload, 'No se pudo eliminar el tipo de tarea.');
  },

  restoreTaskType: async (taskTypeName) => {
    return taskTypeService.updateTaskType(taskTypeName, { isActive: true });
  }
};
